function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxWxAlerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.5 106.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.84,63.68l2.6,24.37a2.1,2.1,0,0,0,2.11,2.11h0a2.11,2.11,0,0,0,2.11-2.11l2.59-24.37A4.71,4.71,0,0,0,76.55,59h0A4.71,4.71,0,0,0,71.84,63.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.55,
    cy: 95.57,
    r: 2.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,89.93,44.08,73.76a1.58,1.58,0,0,1,.66-2.37l8.15-3.47a1.57,1.57,0,0,0,.64-2.39L39.38,46.65A1.58,1.58,0,0,0,38.12,46l-19,0A1.57,1.57,0,0,0,18,48.75L30.94,61.11a1.56,1.56,0,0,1-.37,2.53l-7.15,3.65A1.57,1.57,0,0,0,23.2,70L53.56,92.12A1.57,1.57,0,0,0,55.76,89.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.45 58.42 60.82 58.42 63.94 53.02 48.41 53.02 52.45 58.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.39,27.54a15.32,15.32,0,0,0-4.11.56A18.23,18.23,0,0,0,54.66,13.57,23.44,23.44,0,0,0,10,23.07a18.77,18.77,0,0,0,8.82,35.35h4.44L17.51,53a13.37,13.37,0,0,1-3.77-25.7l.21-.09A13.39,13.39,0,0,1,29.3,31.38a2.7,2.7,0,1,0,4.24-3.33,18.72,18.72,0,0,0-18-6.89,18,18,0,0,1,34.67-4.31,18.2,18.2,0,0,0-5.31,12.87,2.7,2.7,0,0,0,5.4,0A12.78,12.78,0,0,1,55,19.82l.08-.06a12.68,12.68,0,0,1,8.08-2.88A12.85,12.85,0,0,1,76,29.72a10.56,10.56,0,0,1-.06,1.1,15.53,15.53,0,0,0-4.24,5.11,2.7,2.7,0,0,0,1.17,3.63,2.64,2.64,0,0,0,1.23.31,2.72,2.72,0,0,0,2.41-1.47,10.12,10.12,0,0,1,3.48-3.84A10,10,0,1,1,88.8,52.41l2.73,4.73a15.44,15.44,0,0,0-6.14-29.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1,90.91,85.46,53.43a10.29,10.29,0,0,0-17.83,0L52.51,79.62l3,4.19,16.18-28a5.58,5.58,0,0,1,9.67,0L103,93.26a5.59,5.59,0,0,1-4.83,8.38H54.91a5.57,5.57,0,0,1-5-8L46,90.84l0,.07a10.3,10.3,0,0,0,8.92,15.44H98.19a10.3,10.3,0,0,0,8.91-15.44Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxWxAlerts);
export default __webpack_public_path__ + "static/media/tx_WXAlerts.3feee4beff500ee87e4cdd9ab68df15f.svg";
export { ForwardRef as ReactComponent };